import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { NAV } from "@/data/site";
import api from "@/lib/api";

export default function Footer() {
  const [contact, setContact] = useState({});
  useEffect(() => {
    api.get("/content/contact").then((r) => setContact(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="bg-[#12293A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Logo markSize={44} tone="light" />
          <p className="mt-5 text-sm text-white/70 max-w-md leading-relaxed">
            12 Stone Development Group finds and advances development opportunities where land,
            infrastructure, utilities and community growth intersect across the Southeast.
          </p>
          <p className="mt-4 font-mono text-xs text-white/50">12stonetechdev.com</p>
        </div>

        <div>
          <h4 className="font-mono uppercase tracking-widest text-xs text-accent mb-4">Navigate</h4>
          <ul className="space-y-2.5">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-sm text-white/70 hover:text-white transition-colors">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-mono uppercase tracking-widest text-xs text-accent mb-4">Contact</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li className="text-white font-medium">{contact.company || "12 Stone Development Group LLC"}</li>
            {contact.email && <li><a href={`mailto:${contact.email}`} className="hover:text-white">{contact.email}</a></li>}
            {contact.phone && <li>{contact.phone}</li>}
            {contact.address && <li>{contact.address}</li>}
            <li className="pt-3"><Link to="/site-submission" className="text-accent hover:text-white">Submit a Site →</Link></li>
            <li><Link to="/data-room" className="text-accent hover:text-white">Investor Data Room →</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50">© {new Date().getFullYear()} 12 Stone Development Group LLC. All rights reserved.</p>
          <Link to="/login" className="text-xs text-white/40 hover:text-white/70" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
